import angular from 'angular';

angular.module('cloudX').directive('validateEstablishmentNumber', function() {
  return {
    restrict: 'A',
    require: ['?ngModel', '^?bindErrors'],
    link: function(scope, element, attrs, ctrls) {
      var ngModel = ctrls[0];
      var bindErrors = ctrls[1];
      if (!ngModel) return; // do nothing if no ng-model

      ngModel.$validators.establishmentNumber = function(modelValue, viewValue) {
        var value = String(modelValue || viewValue || '').replace(/[^0-9]/g, '');
        if (!value) return true; //Allow empty values, including a blank mask placeholder
        //Establishment numbers are 10 digits starting with 2 to 8 (0 and 1 are enterprise numbers)
        if (!/^[2-8][0-9]{9}$/.test(value)) return false;
        var toTest = value.substr(0, 8);
        var mod = parseInt(toTest) % 97;
        return mod + parseInt(value.substr(8)) === 97;
      };

      if (bindErrors) {
        bindErrors.addError('establishmentNumber', 6017);
      }
    },
  };
});
